import { Box, Card, Stack, Typography, ValidationErrors } from "@compass/core";
import {
  ProviderEmployment as ProviderEmploymentModel,
  ProviderEmploymentEditResource,
  ProviderEmploymentViewResource,
} from "generated/openApi";
import { ProviderEmploymentPageBody } from "pages/providers/provider-employments/ProviderEmploymentPage/ProviderEmploymentPageBody";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const ProviderEmployment = (props: {
  employment: ProviderEmploymentModel;
  setEmployment: (value: ProviderEmploymentModel) => void;
  validationErrors: ValidationErrors | string[];
}) => {
  const [viewResource, setViewResource] = useState<ProviderEmploymentViewResource>({});
  const [editResource, setEditResource] = useState<ProviderEmploymentEditResource>({});

  useEffect(() => {
    fetchEditResource();
    fetchViewResource();
  }, []);

  const fetchEditResource = () => {
    ApiService.providerEmployments.getEditResource().then((response) => {
      setEditResource(response);
    });
  };

  const fetchViewResource = () => {
    ApiService.providerEmployments.getViewResource().then((response) => {
      setViewResource(response);
    });
  };

  return (
    <Card
      header={
        <Stack>
          <Box>Employment</Box>
          <Typography variant="caption">
            An employment is required when creating a provider. You may add more employments after succesfully creating
            this provider.
          </Typography>
        </Stack>
      }
    >
      <ProviderEmploymentPageBody
        crudMode="edit"
        employment={props.employment}
        setEmployment={props.setEmployment}
        viewResource={viewResource}
        editResource={editResource}
        validationErrors={props.validationErrors}
      />
    </Card>
  );
};
